import { Outlet } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import SignedInvoicesPage from 'modules/expenses/pages/SignedInvoices'

const SignedInvoicesTablePage = () => {
  const { navigation } = useNavigation()

  const back = { href: navigation.expenses.fullPath() }
  return (
    <SignedInvoicesPage>
      <Outlet context={{ back }} />
    </SignedInvoicesPage>
  )
}

export default SignedInvoicesTablePage
